import Page from '@/components/custom/Page'
import { WorkspaceLayout } from '@/features/workspace'
import { Button } from '@/shared/components/ui/button'
import { Card } from '@/shared/components/ui/card'
import { Mic, PlayCircle } from 'lucide-react'
import { useRemoteConfigStore } from '@/features/shared/stores/config.store'

export default function V2SInterestPage() {
    const v2sInterestForm = useRemoteConfigStore((state) => state.v2sInterestForm)
    const v2sDemoLink = useRemoteConfigStore((state) => state.v2sDemoLink)
    console.log("v2sInterestForm", v2sInterestForm)
    return (
        <WorkspaceLayout optionBar={<div />}>
            <Page className="bg-primary flex items-center justify-center p-4">
                <Card className="max-w-md w-full p-8 text-center shadow-2xl rounded-3xl space-y-6 border-white/20 bg-white/95 backdrop-blur">
                    <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                        <Mic className="w-8 h-8 text-primary" />
                    </div>
                    <div className="space-y-3">
                        <h2 className="text-2xl font-bold tracking-tight text-slate-900">Voice to Screenplay</h2>
                        <p className="text-slate-600 leading-relaxed text-sm">
                            We're building a powerful new way to craft screenplays using just your voice. It's not fully open to everyone yet.
                        </p>
                        <p className="text-slate-600 font-medium text-sm">
                            Are you interested in trying V2S early?
                        </p>
                    </div>
                    <div className="flex flex-col gap-3 pt-2">
                        {v2sInterestForm && (
                            <Button asChild size="lg" className="rounded-full w-full font-bold shadow-lg hover:shadow-xl transition-all h-12">
                                <a href={v2sInterestForm} target="_blank" rel="noopener noreferrer">
                                    Join the V2S Waitlist
                                </a>
                            </Button>
                        )}
                        {v2sDemoLink && (
                            <Button asChild variant="outline" size="lg" className="rounded-full w-full font-bold h-12 border-primary/20 hover:border-primary/50 text-slate-700">
                                <a href={v2sDemoLink} target="_blank" rel="noopener noreferrer">
                                    <PlayCircle className="w-4 h-4 mr-2" /> Watch Demo
                                </a>
                            </Button>
                        )}
                    </div>
                </Card>
            </Page>
        </WorkspaceLayout>
    )
}
